import { useContext } from 'react';

import { QuestionReviewTaskQuestionDetailsContext } from './question-review-task-question-details-provider';

export function useQuestionReviewTaskQuestionDetails() {
  const context = useContext(QuestionReviewTaskQuestionDetailsContext);

  if (!context) {
    throw new Error(
      'useQuestionReviewTaskQuestionDetails must be used within a QuestionReviewTaskQuestionDetailsProvider',
    );
  }

  return context;
}
